import React from "react";

export function IconPhone() {
  return (
    <svg width="11" height="19" fill="none">
      <path className="phone-icon-path" d="M8.885 0h-6.77A2.116 2.116 0 0 0 0 2.115V16.5c0 1.168.948 2.115 2.115 2.115h6.77A2.116 2.116 0 0 0 11 16.5V2.115A2.116 2.116 0 0 0 8.885 0ZM5.5 17.77c-.702 0-1.27-.568-1.27-1.27 0-.702.568-1.27 1.27-1.27.702 0 1.27.568 1.27 1.27 0 .702-.568 1.27-1.27 1.27Zm3.808-3.385H1.692V2.538h7.616v11.847Z" fill="#000" />
    </svg>
  );
}